export const wholesalePriceFilterState = () => ({
  page: 1,
  perPage: 10,
  batchId: null,
  depot: "All",
  depotId: "all",
  startDate: null,
  endDate: null,
});
